import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { map } from 'rxjs/operators'
import { EntityTagsResponse } from './model'

@Injectable()
export class EntityTagsService {
  constructor(private http: HttpClient) {}

  getAllTags() {
    return this.http
      .get<EntityTagsResponse[]>('@api/tag/all/')
      .pipe(map((items) => items.filter((item) => !!item.entity_type)))
  }

  updateTags(type: string, id: string, tags: string[]) {
    return this.http.put<EntityTagsResponse>(`@api/tag/${type}/${id}/`, { tags })
  }
}
